import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { createService, createModule } from '@/models/core';

const configuration = {
  name: 'provision',
  type: 'node--provision',
  attributes: {
    title: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'title',
    },
    gestoria: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'gestoria_provision',
    },
    hacienda: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'hacienda_provision',
    },
    notario: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'notario_provision',
    },
    registro: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'registro_provision',
    },
    seguro: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'seguro_provision',
    },
    timbres: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'timbres_provision',
    },
    varios: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'varios_provision',
    },
  },
  relationships: {},
};
export const ProvisionService = createService(base, configuration, API_CONFIG.API);
export const ProvisionModule = createModule(ProvisionService, true);



// WEBPACK FOOTER //
// ./src/models/provision.js